import { isInitialized, logCustomEvent } from '@braze/web-sdk';

export const logBrazeEvent = (eventName, properties = {}) => {
  if (
    typeof window !== 'undefined' &&
    'navigator' in window &&
    isInitialized()
  ) {
    logCustomEvent(eventName, {
      ...properties,
      timestamp: new Date().toISOString(),
    });
    // console.log('Braze Event Logged:', eventName, properties);
  }
};
